import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares'
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper'
import WrapperVertCols from 'global/wrappers/WrapperVertCols'
import _ from 'lodash'
import { useContext, useEffect, useState } from 'react'
import { Button, Icon, Label } from 'semantic-ui-react'
import { SportsSeasonContext } from '../cnr/contexts/SportsSeasonContext'
import { useSportsSeasonData } from '../useHelpers/useSportsSeasonData'
import { useSportsMatches } from '../useHelpers/useSportsMatches'
import { _allowSportsUpdates } from '../useHelpers/useSeasonals'

export const ModifySchedules = ({ teamKey }) => {

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}
  const { currentSeason_info, teams_info, matches_info } = sportsSeason_state ?? {}
  const { teams } = teams_info ?? {}
  const { matches_combined } = matches_info ?? {}
  const { gameScoringType, currentSeason: selectedYear, sportsKey } = currentSeason_info ?? {}

  const [matches_season] = useState(_.cloneDeep(matches_combined))
  const [teams_selected, setTeams_selected] = useState([])
  const [updating, setUpdating] = useState()
  const [modifications, setModifications] = useState()

  const { switchTwoTeams } = useSportsMatches()
  const { update_modifiedMatches, update_modifiedTeams } = useSportsSeasonData()

  const handleSelect_team = (team) => {
    setTeams_selected(prev => {
      const alreadySelected = prev.some(
        selected => selected._itemKey === team._itemKey
      );

      // Remove if already selected
      if (alreadySelected) {
        return prev.filter(
          selected => selected._itemKey !== team._itemKey
        );
      }

      // Only allow two teams
      if (prev.length >= 2) {
        return prev;
      }

      // Add team
      return [...prev, team];
    });
  };

  useEffect(() => {
    if (teams_selected.length === 2) {
      switchTwoTeams({
        callback: setModifications,
        teams, matches: matches_season,
        teamKey1: teams_selected[0]._itemKey,
        teamKey2: teams_selected[1]._itemKey,
      })
    } else {
      setModifications(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [teams_selected]);


  const handleUpdate_modified = () => {
    // setUpdating(true) 
    const { updates_matches_grouped, updates_teams } = modifications ?? {}
    if (updates_matches_grouped) {
      const cb = () => setUpdating(false)
      const opts = { selectedYear, sportsKey }

      update_modifiedMatches({
        groupedMatchesToUpdate: updates_matches_grouped,
        opts,
        callback: cb
      })
    }

    if (updates_teams) {
      const cb = () => setUpdating(false)
      const opts = { selectedYear, sportsKey }

      update_modifiedTeams({
        teamsToUpdate: updates_teams,
        opts,
        callback: cb
      })
    }

  }

  const cnt_teams_selected = (item) => cnt_teams(item)

  const cnt_teams = (item, includeDrag) => {
    const { sections, levels, _itemKey } = item
    const t = _.find(teams_selected, { _itemKey })
    return <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '.25em' }}>
      {includeDrag && !_.isEmpty(_matches_opp) && <Label color='blue' size='mini'>{_.size(_matches_opp)}</Label>}
      {t && <Icon name='check circle outline' color='blue' />}
      <Label size='mini'>{levels}</Label>
      <Label size='mini'>{_.startCase(sections)}</Label>
      {includeDrag && <div
        draggable="true"
        onDragStart={(e) => {
          const dt = {
            _itemKey: item._itemKey,
            itemType: 'team',
            name: item?.name,
          }
          e.dataTransfer.setData('application/json', JSON.stringify(dt));
        }}
        style={{ cursor: 'grab' }}
      >
        <Icon color='grey' name='expand arrows alternate' />
      </div>}
    </div>
  }

  const content_teams = (oc) => {
    let _sportSeasonTeams = _.sortBy(teams, 'name')
    return <Wrapper
      header={'Teams'}
      content={<ItemMenuSquares
        menuItems={_sportSeasonTeams}
        iconItem={'users'}
        imsType={_imsTypes.inline}
        onClick={oc}
        activeItems={teams_selected}
        fn_altContent={cnt_teams_selected}
      />}
      wrapperType={wrapperTypes.paddedHeader}
    />
  }

  const cnt_teams_mod = (team) => {
    const { sections, levels, _itemKey, key } = team
    const _keys = key.split('.')
    const _match = matches_season?.[_keys[1]]
    const { home, away } = _match ?? {}
    const opp = home?._itemKey === _itemKey ? away : home
    return <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '.25em' }}>
      <div style={{ color: 'var(--sem-blue)' }}>{`vs ${opp?.name}`}</div>
      <Label size='mini'>{levels}</Label>
      <Label size='mini'>{_.startCase(sections)}</Label>
    </div>
  }

  const content_matches = (oc) => {
    return <Wrapper
      header={`Matches Modified: ${_.size(modifications?.updates_matches)}`}
      content={<ItemMenuSquares
        menuItems={modifications?.updates_matches}
        iconItem={'users'}
        imsType={_imsTypes.inline}
        fn_altContent={cnt_teams_mod}
      />}
      wrapperType={wrapperTypes.paddedHeader}
    />
  }

  const content_teamz = (oc) => {
    return <Wrapper
      header={`Teams Modified: ${_.size(modifications?.updates_teams)}`}
      content={<ItemMenuSquares
        menuItems={modifications?.updates_teams}
        iconItem={'users'}
        imsType={_imsTypes.inline}
        fn_altContent={cnt_teams_mod}
      />}
      wrapperType={wrapperTypes.paddedHeader}
    />
  }

  const footer_main = () => <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
    {modifications && <div><Button
      labelPosition='right'
      content={`Update Modified Match(es)`}
      size='mini'
      color={_allowSportsUpdates.modifications ? 'green' : 'teal'}
      disabled={!modifications || teams_selected.length < 2}
      icon='save'
      onClick={() => { handleUpdate_modified() }} />
    </div>
    }
  </div >

  const mvc_full = () => <WrapperVertCols mvc={3}>
    {teams ? content_teams(handleSelect_team) : <div>Away Team</div>}
    {modifications && content_matches()}
    {modifications && content_teamz()}
  </WrapperVertCols>

  const content_season = () => <Wrapper
    content={mvc_full()}
    footer={footer_main()}
    wrapperType={wrapperTypes.paddedFooter}
  ></Wrapper>

  return (
    content_season()
  )
}
